export const API_URL = process.env.REACT_APP_BOARDS_API_URL;

// PUSHER
export const PUSHER_KEY = process.env.REACT_APP_PUSHER_KEY;
export const PUSHER_CLUSTER = process.env.REACT_APP_PUSHER_CLUSTER;
export const PUSHER_AUTH_ENDPOINT = process.env.REACT_APP_PUSHER_AUTH_ENDPOINT;

